import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import EmailForgotPassword from "./ForgotPassword";
import MobileForgotPassword from "./MobileForgotPassword";

const ForgotPassword2 = () => {
  const [method, setMethod] = useState("mobile");
  const navigate = useNavigate();
  const location = useLocation();
  const type = location.state?.type || "forgot";
  const heading =
    type === "set" ? "Set New Password" : "Forgot Password";
  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        fontFamily: "'Times New Roman', serif",
        background:
          "linear-gradient(135deg, #d4c4e8 0%, #e8ddf5 25%, #fbe8e8 50%, #fdebd0 75%, #efe4fa 100%)",
      }}
    >
      <motion.div
        className="card shadow p-4"
        style={{
          width: "100%",
          maxWidth: "400px",
          borderRadius: "16px",
          fontFamily: "'Times New Roman', serif",
        }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h3
          className="text-center mb-4 fw-bold"
          style={{
            color: "#4b0082",
            fontFamily: "'Times New Roman', serif",
          }}
        >
          {heading}
        </h3>

        {/* Toggle Buttons */}
        {/* Toggle Buttons */}
        <div
          className="d-flex justify-content-center mb-4"
          style={{
            background: "#ffffffaa",
            padding: "4px", // slightly less padding
            borderRadius: "12px",
            border: "1px solid #d8c9f3",
          }}
        >
          {/* EMAIL TAB */}
          {/* <div
            onClick={() => setMethod("email")}
            style={{
              flex: 0.45, // reduced from 0.48 to 0.45
              textAlign: "center",
              padding: "6px", // reduced padding
              cursor: "pointer",
              fontWeight: "bold",
              fontFamily: "'Times New Roman', serif",
              borderRadius: "10px",
              background:
                method === "email"
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)"
                  : "transparent",
              color: method === "email" ? "white" : "#4b0082",
              transition: "0.3s",
              fontSize: "14px",
            }}
          >
            Email
          </div> */}

          {/* MOBILE TAB */}
          <div
            onClick={() => setMethod("mobile")}
            style={{
              flex: 1,
              textAlign: "center",
              padding: "6px",
              cursor: "pointer",
              fontWeight: "bold",
              fontFamily: "'Times New Roman', serif",
              borderRadius: "10px",
              background:
                method === "mobile"
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)"
                  : "transparent",
              color: method === "mobile" ? "white" : "#4b0082",
              transition: "0.3s",
              fontSize: "14px",
            }}
          >
            Mobile
          </div>
        </div>

        {/* Animated content switch */}
        <AnimatePresence mode="wait">
          {/* {method === "email" && (
            <motion.div
              key="email-method"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              <EmailForgotPassword />
            </motion.div>
          )} */}

          {method === "mobile" && (
            <motion.div
              key="mobile-method"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              <MobileForgotPassword />
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default ForgotPassword2;
